"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("@/components/filterColumn/index.vue"));
var _index2 = _interopRequireDefault(require("@/components/Pagination/index.vue"));
var _routeInfo = _interopRequireDefault(require("@/views/booking/bookingSpace/components/routeInfo.vue"));
var _billConsigneeApplication = require("@/api/userCenter/billConsigneeApplication");
var _billButtons = _interopRequireDefault(require("@/views/userCenter/componens/billButtons.vue"));
var _bookingJapan = require("@/api/bookSpace/bookingJapan");
var _fileButtons = _interopRequireDefault(require("@/views/infoSearch/fileButtons.vue"));
var _voyageDetails = _interopRequireDefault(require("@/views/booking/bookingSpace/components/voyageDetails.vue"));
var _confirmPrintingDialog = _interopRequireDefault(require("@/views/import/blExchangeAppointment/components/confirmPrintingDialog.vue"));
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "bookingJapan",
  components: {
    confirmPrintingDialog: _confirmPrintingDialog.default,
    FileButtons: _fileButtons.default,
    Pagination: _index2.default,
    billButtons: _billButtons.default,
    filterColumn: _index.default,
    routeInfo: _routeInfo.default,
    voyageDetails: _voyageDetails.default
  },
  data: function data() {
    return {
      voyagePlanJpVo: {},
      value1: '',
      clientHeight: document.body.clientHeight - 320,
      dataTotal: 0,
      billRules: {
        accountNo: [{
          required: true,
          message: '请输入港口',
          trigger: 'blur'
        }],
        companyName: [{
          required: true,
          message: '请输入公司名称',
          trigger: 'blur'
        }],
        companyNameCn: [{
          required: true,
          message: '请输入公司名称(CN)',
          trigger: 'blur'
        }],
        usci: [{
          required: true,
          message: '请输入USCI',
          trigger: 'blur'
        }]
      },
      editDialog: false,
      dialogType: '',
      tableCostData: [],
      dateValueFormItem: '',
      listQuery: {
        currentPage: 1,
        pageSize: 20,
        total: 0
      },
      portOptions: [{
        value: 'CNSHA',
        label: 'CNSHA'
      }],
      billForm: {
        companyName: '',
        companyNameCn: '',
        usci: '',
        portCode: ''
      },
      selectTableData: {
        searrcForm: {},
        tabledata: []
      },
      searchForm: {
        pol: '',
        pod: '',
        polName: '',
        podName: '',
        etdStr: '',
        tsFlag: '0',
        etaStr: '',
        vesselCode: '',
        serviceLineCode: ''

        // pol: 'TWKEL',
        // pod: 'TWKEL',
      },
      searchFormRules: {
        pol: [{
          required: true,
          message: '',
          trigger: 'change'
        }],
        pod: [{
          required: true,
          message: '',
          trigger: 'change'
        }],
        etdStr: [{
          required: true,
          message: '',
          trigger: 'change'
        }]
      },
      userInfo: {},
      selectionIds: [],
      showMainType: false,
      radio: '',
      statusValueList: [{
        value: 0,
        label: '待提交'
      }, {
        value: 1,
        label: '待审核'
      }, {
        value: 2,
        label: '已审核'
      }, {
        value: 3,
        label: '取消审核'
      }],
      isCancelSubmit: false,
      isCancelDel: false,
      loading: null,
      voyageDetailsVisible: false
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.searchForm.etdStr = this.getNowFormatTime();
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    console.log('    this.userInfo', this.userInfo);
    this.$nextTick(function () {
      _this.resizeHotTable();
    });
  },
  methods: {
    checkSelectable: function checkSelectable(row) {
      return row.status !== 'X';
    },
    /**
     * 序号随页码动态改变
     */
    indexMethod: function indexMethod(index) {
      return index + 1 + (this.listQuery.currentPage - 1) * this.listQuery.pageSize;
    },
    /**
     * currentPage 改变时会触发
     */
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.currentPage = val;
      this.searchFormData();
    },
    /**
     * pageSize 改变时会触发
     */
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.searchFormData();
    },
    polChange: function polChange(value, data) {
      console.log('value,data', value, data);
      this.searchForm.polName = data.portName;
    },
    podChange: function podChange(value, data) {
      console.log('value,data', value, data);
      this.searchForm.podName = data.portName;
    },
    getNowFormatTime: function getNowFormatTime() {
      var nowDate = new Date();
      //补全0，并拼接
      return this.getNowFormatDay(nowDate);
    },
    getNowFormatDay: function getNowFormatDay(nowDate) {
      var char = "-";
      if (nowDate == null) {
        nowDate = new Date();
      }
      var day = nowDate.getDate();
      var month = nowDate.getMonth() + 1; //注意月份需要+1
      var year = nowDate.getFullYear();
      //补全0，并拼接
      return year + char + this.completeDate(month) + char + this.completeDate(day);
    },
    completeDate: function completeDate(value) {
      return value < 10 ? "0" + value : value;
    },
    closeDialog: function closeDialog() {
      this.billForm = {
        companyName: '',
        companyNameCn: '',
        usci: '',
        portCode: ''
      };
    },
    resizeHotTable: function resizeHotTable() {
      this.$refs.hotTableCost.resizeTo();
    },
    resetForm: function resetForm() {
      this.searchForm = {
        pol: '',
        pod: '',
        polName: '',
        podName: '',
        etdStr: '',
        tsFlag: '0',
        etaStr: '',
        vesselCode: '',
        serviceLineCode: ''
      };
    },
    getBookingDetail: function getBookingDetail() {
      console.log('this.selectTableData.tabledata.length', this.selectTableData.tabledata.length);
      if (this.selectTableData.tabledata.length <= 0) {
        this.$message({
          message: this.$t('booking.bookingJapan.selectWarning'),
          type: 'warning'
        });
        return;
      }
      this.selectTableData.searrcForm = this.searchForm;
      this.$router.push({
        path: '/bookingSpace/bookingHistoryJpDetails',
        query: {
          type: 'New',
          addFormData: this.selectTableData
        }
      });
    },
    hotTableSelect: function hotTableSelect(data) {
      var tableData = data;
      var array = [];
      if (this.searchForm.tsFlag == '0') {
        tableData.map(function (item, index) {
          array.push({
            vesselName: item.vesselName,
            voyageNo: item.voyageNo,
            voyageLeg: item.voyageLeg,
            polEtaHidden: item.polEtaHidden,
            polEta: item.polEta,
            etd: item.etd,
            eta: item.eta,
            vesselCode: item.vesselCode,
            vesselNameCn: item.vesselNameCn,
            serviceLineCode: item.serviceLineCode,
            lineType: item.lineType,
            tripNumber: item.tripNumber,
            carrier: item.carrier,
            polHidden: item.polHidden,
            podHidden: item.podHidden
          });
        });
      } else {
        tableData.map(function (item, index) {
          array.push({
            vesselName: item.vesselName,
            voyageNo: item.voyageNo,
            voyageLeg: item.voyageLeg,
            polEtaHidden: item.polEtaStr,
            polEta: item.polEta,
            etd: item.polEtdStr,
            eta: item.podEtaStr,
            vesselCode: item.vesselCode,
            vesselNameCn: item.vesselNameCn,
            serviceLineCode: item.serviceLineCode,
            lineType: item.lineType,
            tripNumber: item.tripNumber,
            carrier: item.carrier,
            polHidden: item.polHidden,
            podHidden: item.podHidden
          });
        });
      }
      this.selectTableData.tabledata = array;
      console.log('this.selectTableData.tabledata', this.selectTableData.tabledata);
      console.log('this.selectTableData', this.selectTableData);
    },
    searchFormData: function searchFormData() {
      var _this2 = this;
      if (!this.searchForm.pol) {
        this.$message({
          message: this.$t('booking.bookingJapan.polWarning'),
          type: 'warning'
        });
        return;
      }
      if (!this.searchForm.pod) {
        this.$message({
          message: this.$t('booking.bookingJapan.podWarning'),
          type: 'warning'
        });
        return;
      }
      if (!this.searchForm.etdStr) {
        this.$message({
          message: this.$t('booking.bookingJapan.etdStrWarning'),
          type: 'warning'
        });
        return;
      }
      this.loading = (0, _utils.load)();
      this.showMainType = true;
      var data = this.searchForm;
      data.currentPage = this.listQuery.currentPage;
      data.pageSize = this.listQuery.pageSize;
      console.log('this.searchForm', this.searchForm);
      (0, _bookingJapan.svlVoyagePlan2queryList)(data).then(function (res) {
        _this2.tableCostData = res.data.records;
        _this2.listQuery.total = res.data.totalRecord;
        _this2.selectionIds = [];
        console.log(' this.tableCostData', _this2.tableCostData);
      }).catch(function (err) {}).finally(function () {
        _this2.loading.close();
      });
    },
    saveFormClick: function saveFormClick() {
      var _this3 = this;
      this.$refs.billFormRef.validate(function (valid) {
        if (valid) {
          if (_this3.dialogType == 'add') {
            _this3.loading = (0, _utils.load)();
            (0, _billConsigneeApplication.addWebBlConsigneeCertification)(_this3.billForm).then(function (res) {
              console.log('res', res);
              _this3.editDialog = false;
              _this3.searchFormData();
              _this3.$message({
                message: _this3.$t('userCenter.billConsigneeApplication.addSuccess'),
                type: 'success'
              });
            }).catch(function (err) {
              _this3.$message({
                message: err.errorMessages[0],
                type: 'error'
              });
            }).finally(function () {
              _this3.loading.close();
            });
          } else if (_this3.dialogType == 'edit') {
            _this3.loading = (0, _utils.load)();
            (0, _billConsigneeApplication.saveWebBlConsigneeCertification)(_this3.billForm).then(function (res) {
              console.log('res', res);
              _this3.editDialog = false;
              _this3.searchFormData();
              _this3.$message({
                message: _this3.$t('userCenter.billConsigneeApplication.editSuccess'),
                type: 'success'
              });
            }).catch(function (err) {
              console.log('err', err);
              _this3.$message({
                message: err.errorMessages[0],
                type: 'error'
              });
            }).finally(function () {
              _this3.loading.close();
            });
          }
        } else {
          return false;
        }
      });
    },
    searchFn: function searchFn(val) {
      this.listQuery.currentPage = val.page;
      this.listQuery.pageSize = val.limit;
      this.handleSearch();
    },
    addClick: function addClick() {
      this.dialogType = 'add';
      this.editDialog = true;
      this.billForm.portCode = 'CNSHA';
    },
    handleViewDetail: function handleViewDetail(selectedRow) {
      this.voyagePlanJpVo = {
        vesselName: selectedRow.vesselName,
        vesselCode: selectedRow.vesselCode,
        voyageNo: selectedRow.voyageNo,
        voyageLeg: selectedRow.voyageLeg,
        serviceLineCode: selectedRow.serviceLineCode
      };
      this.voyageDetailsVisible = true;
    }
  }
};